import clsx from "clsx";

import { QUOTE_COLORS, type QuoteColor } from "lib/quotes/get-quotes";

import CheckIcon from "assets/icons/check.svg?react";
import css from "./color-swatches.module.scss";

type ColorSwatchesProps = {
  selected?: QuoteColor | null;
  onSelect: (color: QuoteColor) => void;
};

export function ColorSwatches({ selected, onSelect }: ColorSwatchesProps) {
  return (
    <div className={css.root}>
      {QUOTE_COLORS.map(color => (
        <button
          key={color}
          className={clsx(css.swatch, `quote-${color}`)}
          onClick={e => {
            e.stopPropagation();
            onSelect(color);
          }}
        >
          {selected === color && <CheckIcon width={12} height={12} />}
        </button>
      ))}
    </div>
  );
}
